/**
 * Trạng thái kiểm tra dự toán theo nguồn 3 năm
 * ndhieu3 23.09.2024
 */
export default {
  /**
   * Chưa kiểm tra
   */
  NotCheck: 1,

  /**
   * Đã kiểm tra
   */
  Checked: 2,
};
